export default __webpack_public_path__ + "_/_/libs/common/src/assets/img/languages/1.png";